import { styled, Box as MuiBox, Typography as MuiTypography } from "@mui/material";

export const Container = styled(MuiBox)(
  ({
    theme: {
      breakpoints,
      palette: {
        custom: { blue, turquoise }
      }
    }
  }) => `
    &.MuiBox-root {
      padding: 16px 32px 32px 40px;
      background-color: ${blue.dark};
      border-radius: 4px;
      position: relative;
      height: 134px;

      &::after {
        content: "";
        position: absolute;
        top: 16px;
        left: 0;
        width: 11px;
        height: 72px;
        background-color: ${turquoise.main};
        border-top-right-radius: 21px;
        border-bottom-right-radius: 21px;
      }

      ${breakpoints.up("md")} {
        padding: 16px 65px 32px 95px;
        border-radius: 10px;
        height: 201px;

        &::after {
          height: 112px;
        }
      }
    }
  `
);

export const ContentWrapper = styled(MuiBox)(
  () => `
    &.MuiBox-root {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
  `
);

export const ValueWrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      & > svg {
        width: 24px;
        height: 24px;
        margin-right: 8px;

        ${breakpoints.up("md")} {
          margin-right: 10px;
          width: 48px;
          height: 48px;
        }
      }
    }
  `
);

export const HeadingText = styled(MuiTypography)(
  ({
    theme: {
      palette: {
        custom: { turquoise }
      },
      typography: { body2 }
    }
  }) => `
    &.MuiTypography-root {
      color: ${turquoise.main};
      font-size: ${body2.mobile.fontSize};
      line-height: ${body2.mobile.lineHeight};
      font-weight: 500;
      text-transform: uppercase;
    }
  `
);

export const ValueText = styled(MuiTypography)(
  ({
    theme: {
      breakpoints,
      palette: {
        custom: { white }
      },
      typography: { h3, h1 }
    }
  }) => `
    &.MuiTypography-root {
      color: ${white.main};
      font-size: ${h3.mobile.fontSize};
      line-height: ${h3.mobile.lineHeight};
      font-weight: 700;
      text-transform: uppercase;

      ${breakpoints.up("md")} {
        font-size: ${h1.mobile.fontSize};
        line-height: ${h1.mobile.lineHeight};
      }
    }
  `
);
